export default {"src":"/_next/static/media/notification-tab.efea2d3e.svg","height":359,"width":264,"blurWidth":0,"blurHeight":0};